
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mailmagazine/thanks",
      function () {
        return require("private-next-pages/mailmagazine/thanks/index.tsx");
      }
    ]);
  